<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" custom-class="edit-goods-dialog" top="10vh" width="1020px" :fullscreen="isExpand" :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <template slot="title">
        <div class="default-dialog-title-box">
          <span>{{ form.id ? '编辑商品': '新增商品' }}</span>
          <span class="icon-box">
            <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
            <i class="el-icon-close" @click="handleClose"></i>
          </span>
        </div>
      </template>
      <el-form :model="form" ref="JZForm" :rules="rules" label-position="right" label-width="130px" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品编码(sku)" prop="sn">
              <el-input v-model.trim="form.sn" readonly placeholder="sku码自动生成"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品名称" prop="goodsName">
              <el-input v-model.trim="form.goodsName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品别名" prop="anotherName">
              <el-input v-model.trim="form.anotherName" placeholder="如输入多个，请用“，”隔开"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="型号" prop="model">
              <el-input v-model.trim="form.model" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="规格">
              <el-input v-model.trim="simpleSpecs" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计量单位" prop="goodsUnit">
              <el-select v-model="form.goodsUnit" filterable placeholder="请选择">
                <el-option v-for="(unit, index) in goodsUnitList" :key="'unit-'+index" :label="unit.optionName" :value="unit.optionName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品分类" prop="merchantGoodsCategoryId">
              <ChooseGoodsCategory ref="chooseGoodsCategoryRef" checkStrictly @handleValidate="handleValidate" @handleSelect="handleSelectCategory" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品品牌" prop="brandName">
              <el-select v-model="form.brandName" @change="handleChangeBrand" filterable remote :remote-method="remoteQueryBrand" value-key="id" placeholder="请选择">
                <el-option v-for="(brand, index) in brandList" :key="'brand-'+index" :label="brand.name" :value="brand"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="原厂备件号" prop="storeSn">
              <el-input v-model.trim="form.storeSn" placeholder="请输入，可输入备件码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="医疗件属性" prop="medicalFlag">
              <el-radio-group v-model="form.medicalFlag" @change="handleChangeMedical">
                <el-radio :label="1">医疗</el-radio>
                <el-radio :label="0">非医疗</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="form.medicalFlag === 1" :span="8">
            <el-form-item label="注册证/备案凭证号" prop="registerCode" label-width="140px">
              <template v-if="form.registerCode">
                <el-input v-model.trim="form.registerCode" readonly>
                  <el-button @click="() => form.registerCode = null" slot="append" icon="el-icon-delete"></el-button>
                </el-input>
              </template>
              <template v-else>
                <span @click="handleChooseRegisterNo" class="button" style="padding-left: 0;">选择注册证</span>
                <span>未找到?</span>
                <span @click="handleAddRegisterNo" class="button">手动新增</span>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="质保期/保修期" prop="qualityAssPeriod"
              :rules="[{
                required: this.form.medicalFlag === 1 || false,
                message: '请选择质保期/保修期',
                trigger: ['blur', 'change']
              }]">
              <el-input v-model.trim="form.qualityAssPeriod" type="number" :min="0" clearable placeholder="请输入" style="width: 60%;" />
              <el-select v-model="form.qualityAssPeriodUnitName" placeholder="请选择" clearable style="width: 40%;" >
                <el-option v-for="(unit,index) in qualityAssPeriodUnitEnums" :label="unit.label" :value="unit.value" :key="'unit-'+index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="line"></div>
        <el-row>
          <el-col :span="24">
            <div class="device-box">
              <div class="device-ctrl">
                <span class="label">适配设备</span>
                <el-tooltip class="item" effect="dark" content="如填写商品为备件类型，请填写适配设备信息" placement="top">
                  <i class="el-icon-warning-outline" style="margin: 0 5px;"></i>
                </el-tooltip>
                <span @click="handleSelectDevice" class="button">
                  {{ form.deviceType === '1' ? '固定设备' : form.deviceType === '2' ? '通用' : '选择设备' }}
                </span>
                <i v-if="form.deviceType" @click="handleClearDevice" class="el-icon-circle-close" style="padding-left: 5px;color: #409EFF;"></i>
              </div>
              <div class="device-list">
                <div v-for="(device, index) in deviceList" :key="'device'+index" class="device">
                  <span>{{ `${device.deviceName} ${device.deviceBrandName} ${device.deviceModel}` }}</span>
                  <i @click="handleDeleteDevice(index)" class="el-icon-circle-close" style="padding-left: 15px;"></i>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片" prop="imageList">
              <Upload
                v-model.trim="imagesList"
                @success="handleFileLists"
                @remove="handleRemove"
                accept="image/png,image/jpeg,image/jpg"
                :maxSize="10"
                size="small"
                :tip="false"
                :limit="10"
              >
              </Upload>
              <div class="tip-upload">支持上传jpg、jpeg、png格式的文件，文件大小不得超过10M，最多上传 10 张</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="from !== 'shop' && (!form.id || form.enableFlag === 2)" @click="handleSure('draft')">保存草稿</el-button>
        <el-button type="primary" @click="handleSure('save')" :plain="!form.id">保存</el-button>
        <el-button v-if="!form.id" type="primary" @click="handleSure('next')">保存并继续录入</el-button>
      </span>
    </el-dialog>

    <SearchRegisterNoDialog ref="searchRegisterNoDialogRef" @select="handleSelectRegisterNo" />

    <CreateRegisterNoDialog ref="createRegisterNoDialogRef" @updateRegistration="getRegistration" />

    <ChooseDeviceDialog ref="chooseDeviceDialogRef" @saveDevice="handleSaveDevice" />
  </div>
</template>
<script>
import { getOptionListMap } from '@/api/contract';
import { updateSku, addSku, skuDetail, getBrandPageList } from '@/api/goods';
import { dictionaryData } from '@/api/inquiryForm';
import SearchRegisterNoDialog from './searchRegisterNoDialog.vue';
import CreateRegisterNoDialog from './createRegisterNoDialog.vue';
import ChooseDeviceDialog from './chooseDeviceDialog.vue';
import ChooseGoodsCategory from './chooseGoodsCategory.vue';
export default {
  props: {
    from: {
      type: String,
      default: '',
    },
  },
  components: {
    Upload: () => import('@/components/common/upload'),
    SearchRegisterNoDialog,
    CreateRegisterNoDialog,
    ChooseDeviceDialog,
    ChooseGoodsCategory,
  },
  data () {
    return {
      isExpand: false,
      dialogVisible: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      simpleSpecs: '',
      form: {
        id: null,
        enableFlag: null,
        anotherName: null,
        brandId: null,
        brandName: null,
        deviceId: null,
        deviceType: null,
        draftFlag: false,
        goodsName: null,
        goodsUnit: null,
        managerCategory: null,
        imageList: [],
        attributeMap: {},
        medicalFlag: 0,
        merchantGoodsCategoryId: null,
        merchantGoodsCategoryPath: null,
        model: null,
        qualityAssPeriod: null,
        qualityAssPeriodUnitName: '月',
        registerCode: null,
        storeSn: null,
      },
      imagesList: [],
      deviceList: [],
      qualityAssPeriodUnitEnums: [],
      goodsUnitList: [],
      brandList: [],
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: ['blur', 'change'] },
        ],
        model: [
          { required: true, message: '请输入商品型号', trigger: ['blur', 'change'] },
        ],
        goodsUnit: [
          { required: true, message: '请选择计量单位', trigger: ['blur', 'change'] },
        ],
        medicalFlag: [
          { required: true, message: '请选择医疗件属性', trigger: ['blur', 'change'] },
        ],
        registerCode: [
          { required: true, message: '请选择注册证/备案凭证', trigger: ['blur', 'change'] },
        ],
        imageList: [
          { required: true, validator: this.validateImages, trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  watch: {
    dialogVisible (v) {
      if (!v) {
        this.init();
      } else {
        if (!this.qualityAssPeriodUnitEnums.length) {
          this.getUnitDictionaryData();
        }
        if (!this.goodsUnitList.length) {
          this.getGoodsUnitList();
        }
        this.getBrandList();
      }
    },
  },
  methods: {
    validateImages (rule, value, callback) {
      if (!value?.length) {
        callback(new Error('请上传商品图片'));
      } else {
        callback();
      }
    },
    handleValidate () {
      this.$refs.JZForm.clearValidate('merchantGoodsCategoryId');
    },
    getRegistration (v) {
      this.form.registerCode = v.registrationCode;
      this.form.managerCategory = v.category;
      this.$refs.JZForm.clearValidate('registerCode');
    },
    handleSelectCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.merchantGoodsCategoryId = categoryId;
      this.form.merchantGoodsCategoryPath = v.value.join(',');
    },
    handleClearDevice () {
      this.form.deviceType = null;
      this.deviceList = [];
    },
    handleSelectDevice () {
      this.$refs.chooseDeviceDialogRef.deviceType = this.form.deviceType || '1';
      this.$refs.chooseDeviceDialogRef.selectedKeys = this.deviceList.map(item => item.deviceId);
      this.$refs.chooseDeviceDialogRef.selectedLists = this.deviceList.map(item => {
        return {
          id: item.deviceId,
          name: item.deviceName,
          model: item.deviceModel,
          brandName: item.deviceBrandName,
          brandId: item.deviceBrandId,
          categoryId: item.deviceCategoryId,
          categoryName: item.deviceCategoryName,
          categoryAllName: item.deviceCategoryName,
          registerCode: item.deviceRegisterCode,
        };
      });
      this.$refs.chooseDeviceDialogRef.dialogVisible = true;
    },
    handleAddRegisterNo () {
      this.$refs.createRegisterNoDialogRef.dialogVisible = true;
    },
    handleChooseRegisterNo () {
      this.$refs.searchRegisterNoDialogRef.dialogVisible = true;
    },
    handleSelectRegisterNo (info) {
      this.form.registerCode = info.registrationCode;
      this.form.managerCategory = info.category;
    },
    handleRemove (file) {
      const index = this.imagesList.findIndex(v => v.url === file.url);
      this.imagesList.splice(index, 1);
      this.form.imageList = this.imagesList;
      this.$refs.JZForm.validateField('imageList');
    },
    handleDeleteDevice (i) {
      this.$delete(this.deviceList, i);
    },
    handleSaveDevice (data) {
      this.form.deviceType = data.deviceType;
      if (this.form.deviceType === '2') {
        this.deviceList = [];
      } else {
        this.deviceList = data.selectedLists.map(item => {
          return {
            deviceId: item.id,
            deviceName: item.name,
            deviceModel: item.model,
            deviceBrandName: item.brandName,
            deviceBrandId: item.brandId,
            deviceCategoryId: item.categoryId,
            deviceCategoryName: item.categoryAllName || item.categoryName,
          };
        });
      }
    },
    handleFileLists (file) {
      this.imagesList.push({
        name: file.name,
        url: file.url,
      });
      this.form.imageList = this.imagesList;
      this.$refs.JZForm.clearValidate('imageList');
    },
    handleClose () {
      this.dialogVisible = false;
    },
    handleSure (type) {
      this.$refs.JZForm.validate().then(async valid => {
        if (valid) {
          const api = this.form.id ? updateSku : addSku;
          if (type === 'draft') {
            this.form.draftFlag = true;
          } else {
            this.form.draftFlag = false;
          }
          if (this.form.qualityAssPeriod && !this.form.qualityAssPeriodUnitName) {
            this.$message.warning('请选择质保期/保修期单位');
            return;
          }
          if (this.form.id && !this.form.qualityAssPeriod) {
            this.form.clearQualityAssPeriod = true;
          }
          if (this.form.medicalFlag === 0) {
            this.form.registerCode = '';
            this.form.managerCategory = '';
          }
          if (this.simpleSpecs) {
            this.form.attributeMap['规格'] = this.simpleSpecs;
          }
          await api({
            ...this.form,
            medicalFlag: !!this.form.medicalFlag || false,
            deviceType: this.form.deviceType || '2',
            deviceList: this.form.deviceType === '1' ? this.deviceList : null,
          });
          if (this.from === 'shop' && this.form.id) {
            this.$message.success('保存成功');
            const { body } = await skuDetail({id: this.form.id, findDeviceFlag: true});
            this.$emit('refresh', body);
            this.handleClose();
            return;
          }
          if (type !== 'next') {
            this.$message.success('保存成功');
            this.$emit('refresh');
            this.handleClose();
          } else {
            this.$message.success('保存成功，请继续录入');
            this.$emit('refresh');
            this.init();
          }
        }
      });
    },
    init () {
      this.form = this.$options.data().form;
      this.simpleSpecs = '';
      this.imagesList = [];
      this.deviceList = [];
      this.$nextTick(() => {
        this.$refs.JZForm.resetFields();
        this.$refs.chooseGoodsCategoryRef.defaultValue = [];
      });
    },
    async initForm (id) {
      const { body } = await skuDetail({id, findDeviceFlag: true});
      const imageList = body.skuImages?.length ? body.skuImages.map(img => {
        return {
          name: img,
          url: img,
        };
      }) : [];
      this.imagesList = imageList;
      this.simpleSpecs = body.simpleSpecs.trim();
      this.deviceList = body.deviceList ? body.deviceList : [];
      this.form = {
        id: body.id || null,
        sn: body.sn || null,
        enableFlag: body.enableFlag || null,
        anotherName: body.anotherName || null,
        brandId: body.brandId || null,
        brandName: body.brandName || null,
        deviceId: body.deviceList?.length ? body.deviceList.map(item => item.deviceId).join(',') : '',
        deviceType: body.deviceType || null,
        goodsName: body.goodsName || null,
        goodsUnit: body.goodsUnit || null,
        managerCategory: body.managerCategory || null,
        merchantGoodsCategoryId: body.merchantGoodsCategoryId || null,
        merchantGoodsCategoryPath: body.merchantGoodsCategoryPath || null,
        model: body.model || null,
        qualityAssPeriod: body.qualityAssPeriod || null,
        qualityAssPeriodUnitName: body.qualityAssPeriodUnitName || null,
        registerCode: body.registerCode || null,
        storeSn: body.storeSn || null,
        draftFlag: false,
        imageList,
        medicalFlag: body.medicalFlag ? 1 : 0,
        attributeMap: {},
      };
      this.$refs.chooseGoodsCategoryRef.defaultValue = this.form.merchantGoodsCategoryPath ? this.form.merchantGoodsCategoryPath.split(',') : [];
    },
    async getUnitDictionaryData () {
      const {body} = await getOptionListMap({
        enableFlag: 1,
        typeCode: '7hCUTL',
      });
      if (body?.['7hCUTL']) {
        this.qualityAssPeriodUnitEnums = (body['7hCUTL'] || []).map(item => {
          return {
            label: item.optionName,
            value: item.optionName,
          };
        });
      }
    },
    async getGoodsUnitList () {
      const { body } = await dictionaryData({
        enableFlag: 1,
        typeCode: 'MEASURE_UNIT',
      });
      this.goodsUnitList = body || [];
    },
    remoteQueryBrand (query) {
      if (query.trim()) this.getBrandList(query);
    },
    handleChangeBrand (val) {
      this.form.brandId = val.id;
      this.form.brandName = val.name;
    },
    handleChangeMedical (v) {
      if (v === 0) {
        this.form.qualityAssPeriodUnitName = null;
      } else {
        this.form.qualityAssPeriodUnitName = '月';
      }
    },
    async getBrandList (query = '') {
      const { body } = await getBrandPageList({
        nameOrShortName: query,
        enableFlag: true,
        orderBy: [
          {
            orderByProperty: 'createTime',
            orderByType: 'ASC',
          },
        ],
        pageNum: 1,
        pageSize: 10,
      });
      this.brandList = body?.list || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-goods-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
  .line {
    height: 1px;
    background-color: #eeeeee;
    margin: 15px 0;
  }
  .device-box {
    display: flex;
    padding-bottom: 15px;
    .device-ctrl {
      flex-shrink: 0;
      height: 30px;
      display: inline-flex;
      align-items: center;
      .label {
        display: inline-block;
        width: 120px;
        text-align: right;
      }
    }
    .device-list {
      display: inline-flex;
      flex-direction: column;
      .device {
        flex-shrink: 0;
        padding: 3px 10px;
        margin: 0 5px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        &:hover {
          background-color: #eee;
          cursor: default;
        }
      }
    }
  }
  .tip-upload {
    font-weight: 400;
    font-size: 14px;
    color: #929AA6;
  }
  .button {
    color: #409EFF;
    padding: 0 5px;
    cursor: default;
  }
}
</style>
